import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

const FormularzUrzadzen = ({ onSave, onCancel, adresy, selectedAdresId }) => {
  const [deviceData, setDeviceData] = useState({
    nazwa: '',
    model: '',
    typ: '',
    rodzaj: '',
    numer_seryjny: '',
    uwagi: '',
    id_adres: selectedAdresId || '',
    interwal_przegladow: 0,
    gwarancja: 0,
    data_montazu: '',
    data_ostatniego_przegladu: ''
  });

  // Przechowujemy wszystkie opcje pobrane z API (tabela lista_urzadzen)
  const [deviceOptions, setDeviceOptions] = useState([]);
  // Przechowujemy opcje dla każdego pola po przefiltrowaniu wg aktualnych wyborów
  const [filteredOptions, setFilteredOptions] = useState({
    typ: [],
    rodzaj: [],
    nazwa: [],
    model: []
  });

  // Uaktualnienie przypisanego adresu, jeśli selectedAdresId ulegnie zmianie
  useEffect(() => {
    if (selectedAdresId) {
      setDeviceData(prev => ({ ...prev, id_adres: selectedAdresId }));
    }
  }, [selectedAdresId]);
  const token = localStorage.getItem('token');
  // Pobranie opcji z endpointu /lista-urzadzen przy pierwszym renderze
  useEffect(() => {
    fetch(`${API_URL}/lista-urzadzen`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(response => response.json())
      .then(data => {
        setDeviceOptions(data);
      })
      .catch(error => console.error("Error fetching device options:", error));
  }, [token]);

  // Obliczanie przefiltrowanych opcji dla pól: typ, rodzaj, nazwa, model
  useEffect(() => {
    const fields = ['typ', 'rodzaj', 'nazwa', 'model'];
    const newFiltered = {};
    fields.forEach(field => {
      // Dla danego pola zbieramy unikalne opcje z wierszy, które spełniają kryteria dla pozostałych pól
      newFiltered[field] = Array.from(new Set(
        deviceOptions
          .filter(row =>
            fields
              .filter(f => f !== field && deviceData[f])
              .every(f => row[f] === deviceData[f])
          )
          .map(row => row[field])
      ));
    });
    setFilteredOptions(newFiltered);
  }, [deviceOptions, deviceData.typ, deviceData.rodzaj, deviceData.nazwa, deviceData.model]);

  // Jeśli filtr zwraca dokładnie jeden pasujący wiersz, ustaw domyślne wartości dla interwału i gwarancji
  useEffect(() => {
    const fields = ['typ', 'rodzaj', 'nazwa', 'model'];
    const matchingRows = deviceOptions.filter(row =>
      fields.every(field =>
        deviceData[field] ? row[field] === deviceData[field] : true
      )
    );
    if (matchingRows.length === 1) {
      const selectedOption = matchingRows[0];
      setDeviceData(prev => ({
        ...prev,
        interwal_przegladow: selectedOption.interwal_przegladow,
        gwarancja: selectedOption.gwarancja,
      }));
    }
  }, [deviceOptions, deviceData.typ, deviceData.rodzaj, deviceData.nazwa, deviceData.model]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDeviceData(prev => ({ ...prev, [name]: value }));
    console.log(deviceData)
  };

  const selectedAddress = adresy.find(adres => adres.id_adres === selectedAdresId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("🔍 Dane przesyłane do handleAddDevice:", deviceData);

    if (!deviceData.numer_seryjny || deviceData.numer_seryjny.length < 3) {
      alert("Numer seryjny musi mieć co najmniej 3 znaki!");
      return;
    }

    if (!deviceData.nazwa || deviceData.nazwa.length < 2) {
      alert("Nazwa musi mieć co najmniej 2 znaki!");
      return;
    }

    // Ustawiamy data_ostatniego_przegladu równą data_montazu
    const deviceDataToSend = {
      ...deviceData,
      data_ostatniego_przegladu: deviceData.data_montazu
    };

    onSave(deviceDataToSend);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        {/* Pole Nazwa – select */}
        <div>
          <label>
            Nazwa:
            <select name="nazwa" value={deviceData.nazwa} onChange={handleInputChange} required>
              <option value="">-- Wybierz nazwę --</option>
              {filteredOptions.nazwa.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </label>
        </div>
        {/* Pole Model – select */}
        <div>
          <label>
            Model:
            <select name="model" value={deviceData.model} onChange={handleInputChange} required>
              <option value="">-- Wybierz model --</option>
              {filteredOptions.model.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </label>
        </div>
        {/* Pole Typ – select */}
        <div>
          <label>
            Typ:
            <select name="typ" value={deviceData.typ} onChange={handleInputChange} required>
              <option value="">-- Wybierz typ --</option>
              {filteredOptions.typ.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </label>
        </div>
        {/* Pole Rodzaj – select */}
        <div>
          <label>
            Rodzaj:
            <select name="rodzaj" value={deviceData.rodzaj} onChange={handleInputChange} required>
              <option value="">-- Wybierz rodzaj --</option>
              {filteredOptions.rodzaj.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </label>
        </div>
        <div>
          <label>
            Numer seryjny:
            <input
              name="numer_seryjny"
              type="text"
              value={deviceData.numer_seryjny}
              onChange={handleInputChange}
              required
            />
          </label>
        </div>
        {/* Adres – tylko do odczytu */}
        <div>
          <label>
            Adres:
            <input
              type="text"
              value={selectedAddress ? `${selectedAddress.ulica}, ${selectedAddress.miasto}` : 'Nieznany adres'}
              disabled
            />
          </label>
        </div>
        {/* Interwał przeglądów – domyślnie uzupełniany, ale modyfikowalny */}
        <div>
          <label>
            Interwał przeglądów:
            <input
              name="interwal_przegladow"
              type="number"
              value={deviceData.interwal_przegladow}
              onChange={handleInputChange}
              required
            />
          </label>
        </div>
        {/* Gwarancja urządzenia – nowe pole */}
        <div>
          <label>
            Gwarancja urządzenia:
            <input
              name="gwarancja"
              type="number"
              value={deviceData.gwarancja || ""}
              onChange={handleInputChange}
              required
            />
          </label>
        </div>
        {/* Data montażu */}
        <div>
          <label>
            Data montażu:
            <input
              name="data_montazu"
              type="date"
              value={deviceData.data_montazu}
              onChange={handleInputChange}
              required
            />
          </label>
        </div>
        {/* Uwagi */}
        <div>
          <label>
            Uwagi:
            <textarea name="uwagi" value={deviceData.uwagi} onChange={handleInputChange} />
          </label>
        </div>
        <div>
          <button type="submit">Dodaj urządzenie</button>
          <button type="button" onClick={onCancel}>Anuluj</button>
        </div>
      </form>
    </div>
  );
};

export default FormularzUrzadzen;
